import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="toast"
export default class extends Controller {
  static values = { timeout: { type: Number, default: 5000 } }

  connect() {
    this._timer = window.setTimeout(() => this.dismiss(), this.timeoutValue)
  }

  disconnect() {
    if (this._timer) window.clearTimeout(this._timer)
  }

  dismiss() {
    this.element.classList.add("hidden")
  }
}


